import { findKeyInObj, findKeyParentInObj } from 'app/utils/objects';
import { noticeError } from 'app/api/analytics/reporting';

export function callApiByName(methodStr, params) {
  const apiFunc = findKeyInObj(window, methodStr);
  const apiContext = findKeyParentInObj(window, methodStr);
  if (apiFunc && apiContext) {
    return apiFunc.apply(apiContext, params);
  }
  noticeError(`Feeny API method not found: ${methodStr}`);
  return Promise.reject();
}



// WEBPACK FOOTER //
// ./src/app/api/redux-feeny/proxy.js